export default __webpack_public_path__ + "static/media/RYS_9039.4979a3bb.jpg";